import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Flex, Dropdown, Box, Spinner } from "samba-ui";
import styled from "styled-components";
import { updateUserRole } from "../redux/users";
const dropdownOptions = [
  { label: "Samba TV Admin", value: "superadmin" },
  { label: "Samba TV Operator", value: "superoperator" }
];

const StyledBox = styled(Box)`
  opacity: ${p => (p.disabled ? 0.5 : 1)};
  pointer-events: ${p => (p.disabled ? "none" : "auto")};
`;

const SetUserRole = ({ profile, user, updateUserRole }) => {
  useEffect(() => {
    setSelectedRole(
      user.role === "superadmin" ? dropdownOptions[0] : dropdownOptions[1]
    );
  }, [user]);
  const [showSpinner, setShowSpinner] = useState(false);
  const isSuperOperator = profile.role === "superoperator";
  const [selectedRole, setSelectedRole] = useState({});

  const onRoleSelect = async selected => {
    setShowSpinner(true);
    const body = {
      userId: user.userId,
      role: selected.value
    };
    await updateUserRole(body);
    setSelectedRole(selected);
    setShowSpinner(false);
  };

  if (showSpinner) {
    return (
      <Flex justifyContent="center">
        <Spinner variant="xsmall" />
      </Flex>
    );
  }

  if (user.role === "operator" || profile.email === user.email) {
    return null;
  }
  return (
    <StyledBox disabled={isSuperOperator}>
      <Dropdown
        options={dropdownOptions}
        selected={selectedRole}
        onSelect={onRoleSelect}
      />
    </StyledBox>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  updateUserRole: body => dispatch(updateUserRole(body))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SetUserRole);
